import { FirefoxPipManager } from './firefox-pip-manager';
export class BrowserDisplay {
    enablePictureInPicture;
    disablePictureInPicture;
    constructor(deviceInfo) {
        if (/firefox/i.test(deviceInfo.browserName)) {
            const pipManager = new FirefoxPipManager();
            this.enablePictureInPicture = (videoElement) => {
                return pipManager.enablePip(videoElement);
            };
            this.disablePictureInPicture = (videoElement) => {
                return pipManager.disablePip(videoElement);
            };
        }
    }
    supportsResizeWithHdr() {
        return true;
    }
    supportsResizeWithUhd() {
        return true;
    }
}
//# sourceMappingURL=browser-display.js.map